import { FC, useEffect, useRef, useState } from 'react';
import { Button } from '../../basics';
import { PinVerification, Popover } from '../../elements';
import { User } from '../../../types/verification';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../../states/hooks/useAuth/useAuth';
import PageLayout from '../../layouts/PageLayout/PageLayout';

type Props = {
};

const LoginPage: FC<Props> = () => {
    const { id } = useParams();
    const authState = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [ showPinPad, setShowPinPad ] = useState(true);
    
    const handleVerificationComplete = (user: User) => {
        setShowPinPad(false)
        
        const redirectedPage = (location?.state as any)?.from;
        if (redirectedPage) {
            navigate(redirectedPage);
        } else {
            navigate('/');
        }
    }
    
    const handleVerificationError = (error: any) => {}
    
    const login = () => {
        setShowPinPad(true);
    }
    
    if (!id) return <Navigate to="/session" replace />
    
    const selectedSession = authState.getSessionById(id);
    
    if (!selectedSession) return <Navigate to="/session" replace />
    
    return <>
        <PageLayout>
            <div className="flex-1">
                <div className="pre-heading">Hi, { selectedSession.user.firstName }</div>
                <div className="heading">Verifieer dat jij het bent</div>
            </div>
            <Button theme="main" onClick={ login } loading={ authState.loading } className="mb-4">Aanmelden</Button>
            <Link to="/session">
                <Button theme="secondary">Ander account</Button>
            </Link>
        </PageLayout>
        
        <Popover active={ showPinPad } onClose={() => setShowPinPad(false)}>
            <PinVerification session={{ email: selectedSession.user.email }} onComplete={ handleVerificationComplete } onError={ handleVerificationError } />
        </Popover>
    </>
}

export default LoginPage;